import { useState } from "react";
import { depthPosts } from "@/mocks/homeData";

export default function DepthSection() {
  const [openId, setOpenId] = useState<string | null>(null);
  const toggle = (id: string) => setOpenId((v) => (v === id ? null : id));

  return (
    <section id="deep" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-accent-600">
              <i className="ri-scales-3-line" />
              Deep Dive
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              深度观察
            </h2>
            <p className="mt-1 max-w-2xl text-sm text-foreground-700">
              不止记录"发生了什么"，更拆解"为什么会发生"。关于涨粉、停更、转型与变现的方法论，都在这里慢慢展开。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full bg-background-100 px-4 py-2 text-xs text-foreground-600 ring-1 ring-background-200">
            <i className="ri-book-open-line text-accent-600" />
            双周更新 · 已出 {depthPosts.length} 期
          </span>
        </div>

        <div className="mt-8 space-y-5">
          {depthPosts.map((d, idx) => {
            const isOpen = openId === d.id;
            return (
              <article
                key={d.id}
                className={`flex flex-col gap-0 overflow-hidden rounded-3xl border border-background-200 bg-background-100/60 lg:flex-row ${
                  idx % 2 === 1 ? "lg:flex-row-reverse" : ""
                }`}
              >
                <div className="relative lg:w-1/2">
                  <div className="h-52 w-full sm:h-64 lg:h-full lg:min-h-[280px]">
                    <img
                      src={d.image}
                      alt={d.title}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <span className="absolute left-4 top-4 font-heading text-5xl font-black text-background-50 drop-shadow-sm md:text-6xl">
                    {d.index}
                  </span>
                  <span className="absolute right-4 top-4 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-800 backdrop-blur">
                    {d.date}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-5 md:p-7">
                  <div className="flex flex-wrap items-center gap-2 text-xs">
                    <span className="rounded-md bg-accent-100 px-2.5 py-1 font-semibold text-accent-800">
                      {d.category}
                    </span>
                    <span className="inline-flex items-center gap-1 text-foreground-500">
                      <i className="ri-time-line" />
                      阅读约 {d.readTime}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                    {d.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">{d.excerpt}</p>

                  {isOpen && (
                    <p className="mt-3 border-l-2 border-accent-300 pl-4 text-sm leading-relaxed text-foreground-700">
                      我们会持续补充公开信源、对比前后数据，并跟进后续反转。想要第一时间收到更新，可在下方订阅瓜友日报，或通过投稿表单把线索丢给我们——你看到的蛛丝马迹，或许正是下一条头条的起点。
                    </p>
                  )}

                  <div className="mt-5 flex flex-wrap items-center gap-3 border-t border-background-200 pt-4">
                    <button
                      type="button"
                      onClick={() => toggle(d.id)}
                      className="inline-flex h-9 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                    >
                      {isOpen ? "收起" : "展开细读"}
                      <i className={isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
                    </button>
                    <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                      <i className="ri-lock-2-line" />
                      每期独立成文，可放心收藏阅读
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}